import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import classNames from 'classnames/bind';
import React, { memo } from 'react';
import style from './LoadingCube.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, style);
var LoadingCube = /*#__PURE__*/memo(function (_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? '100%' : _ref$height,
    _ref$viewBox = _ref.viewBox,
    viewBox = _ref$viewBox === void 0 ? '0 0 110 110' : _ref$viewBox;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: cx('loadingCube'),
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    width: width,
    height: height,
    viewBox: viewBox
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube5-fill",
    className: "cube5-fill",
    x1: "161.410000",
    y1: "188.643331",
    x2: "194.070000",
    y2: "155.983331",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube5-fill-0",
    offset: "0%",
    stopColor: "rgb(2,180,136)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube5-fill-1",
    offset: "100%",
    stopColor: "rgb(1,175,149)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube6-fill",
    className: "cube6-fill",
    x1: "173.029000",
    y1: "-11.631500",
    x2: "347.707200",
    y2: "283.006400",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube6-fill-0",
    offset: "0%",
    stopColor: "rgb(3,199,90)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube6-fill-1",
    offset: "28.140000%",
    stopColor: "rgb(3,195,99)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube6-fill-2",
    offset: "73.890000%",
    stopColor: "rgb(4,182,123)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube6-fill-3",
    offset: "100%",
    stopColor: "rgb(4,174,140)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube7-fill",
    className: "cube7-fill",
    x1: "135.156000",
    y1: "10.821700",
    x2: "309.834300",
    y2: "305.459600",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube7-fill-0",
    offset: "0%",
    stopColor: "rgb(3,199,90)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube7-fill-1",
    offset: "28.140000%",
    stopColor: "rgb(3,195,99)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube7-fill-2",
    offset: "73.890000%",
    stopColor: "rgb(4,182,123)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube7-fill-3",
    offset: "100%",
    stopColor: "rgb(4,174,140)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube9-fill",
    className: "cube9-fill",
    x1: "161.410000",
    y1: "278.600000",
    x2: "194.043790",
    y2: "245.439880",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube9-fill-0",
    offset: "0%",
    stopColor: "rgb(0,160,184)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube9-fill-1",
    offset: "100%",
    stopColor: "rgb(2,156,197)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube10-fill",
    className: "cube10-fill",
    x1: "0",
    y1: "0",
    x2: "0.850000",
    y2: "1",
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube10-fill-0",
    offset: "0%",
    stopColor: "rgb(1,162,180)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube10-fill-1",
    offset: "100%",
    stopColor: "rgb(0,155,197)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube11-fill",
    className: "cube11-fill",
    x1: "-16.330000",
    y1: "-16.330000",
    x2: "16.329998",
    y2: "16.330000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube11-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,131)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube11-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube14-fill",
    className: "cube14-fill",
    x1: "116.270000",
    y1: "111.200011",
    x2: "83.746669",
    y2: "143.860000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube14-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,131)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube14-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube15-fill",
    className: "cube15-fill",
    x1: "-81.439202",
    y1: "297.331706",
    x2: "93.238998",
    y2: "591.969506",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube15-fill-0",
    offset: "0%",
    stopColor: "rgb(3,199,90)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube15-fill-1",
    offset: "28.140000%",
    stopColor: "rgb(3,195,99)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube15-fill-2",
    offset: "73.890000%",
    stopColor: "rgb(4,182,123)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube15-fill-3",
    offset: "100%",
    stopColor: "rgb(4,174,140)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube16-fill",
    className: "cube16-fill",
    x1: "-16.441839",
    y1: "16.304662",
    x2: "16.229629",
    y2: "-16.368382",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube16-fill-0",
    offset: "0%",
    stopColor: "rgb(0,160,184)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube16-fill-1",
    offset: "100%",
    stopColor: "rgb(0,154,199)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube17-fill",
    className: "cube17-fill",
    x1: "161.176961",
    y1: "278.600000",
    x2: "193.836961",
    y2: "246.014284",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube17-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,131)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube17-fill-1",
    offset: "100%",
    stopColor: "rgb(1,175,149)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube20-fill",
    className: "cube20-fill",
    x1: "194.310427",
    y1: "189.144072",
    x2: "161.513758",
    y2: "156.484072",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube20-fill-0",
    offset: "0%",
    stopColor: "rgb(0,160,185)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube20-fill-1",
    offset: "100%",
    stopColor: "rgb(0,155,196)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube21-fill",
    className: "cube21-fill",
    x1: "267.034631",
    y1: "138.961039",
    x2: "244.172631",
    y2: "116.099039",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube21-fill-0",
    offset: "1%",
    stopColor: "rgb(2,180,136)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube21-fill-1",
    offset: "100%",
    stopColor: "rgb(1,175,148)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube22-fill",
    className: "cube22-fill",
    x1: "135.156000",
    y1: "10.821700",
    x2: "309.834300",
    y2: "305.459600",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube22-fill-0",
    offset: "0%",
    stopColor: "rgb(3,199,90)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube22-fill-1",
    offset: "28.140000%",
    stopColor: "rgb(3,195,99)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube22-fill-2",
    offset: "73.890000%",
    stopColor: "rgb(4,182,123)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube22-fill-3",
    offset: "100%",
    stopColor: "rgb(4,174,140)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube24-fill",
    className: "cube24-fill",
    x1: "194.070000",
    y1: "245.940000",
    x2: "161.410000",
    y2: "278.600000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube24-fill-0",
    offset: "0%",
    stopColor: "rgb(0,160,185)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube24-fill-1",
    offset: "100%",
    stopColor: "rgb(0,154,199)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube25-fill",
    className: "cube25-fill",
    x1: "-0",
    y1: "1",
    x2: "1",
    y2: "-0",
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube25-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,130)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube25-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,150)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube26-fill",
    className: "cube26-fill",
    x1: "-16.330000",
    y1: "-16.330000",
    x2: "16.329998",
    y2: "16.330000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube26-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,131)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube26-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube27-fill",
    className: "cube27-fill",
    x1: "-0",
    y1: "1",
    x2: "1",
    y2: "0",
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube27-fill-0",
    offset: "0%",
    stopColor: "rgb(1,162,180)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube27-fill-1",
    offset: "100%",
    stopColor: "rgb(0,154,199)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube30-fill",
    className: "cube30-fill",
    x1: "244.100000",
    y1: "116.100000",
    x2: "266.798335",
    y2: "138.960000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube30-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,131)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube30-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube31-fill",
    className: "cube31-fill",
    x1: "0",
    y1: "0",
    x2: "0.997726",
    y2: "1",
    spreadMethod: "pad",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube31-fill-0",
    offset: "0%",
    stopColor: "rgb(3,199,90)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube31-fill-1",
    offset: "100%",
    stopColor: "rgb(3,194,101)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube32-fill",
    className: "cube32-fill",
    x1: "-16.330000",
    y1: "-16.330000",
    x2: "16.329998",
    y2: "16.330000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube32-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,131)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube32-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube35-fill",
    className: "cube35-fill",
    x1: "266.960000",
    y1: "116.100000",
    x2: "244.100000",
    y2: "138.960000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube35-fill-0",
    offset: "0%",
    stopColor: "rgb(3,199,90)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube35-fill-1",
    offset: "100%",
    stopColor: "rgb(3,196,98)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube36-fill",
    className: "cube36-fill",
    x1: "194.070000",
    y1: "156.120000",
    x2: "161.410000",
    y2: "188.780000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube36-fill-0",
    offset: "0%",
    stopColor: "rgb(2,180,136)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube36-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube37-fill",
    className: "cube37-fill",
    x1: "116.270000",
    y1: "111.200000",
    x2: "83.610000",
    y2: "143.860000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube37-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,132)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube37-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube39-fill",
    className: "cube39-fill",
    x1: "116.270000",
    y1: "143.398569",
    x2: "83.717293",
    y2: "111.200000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube39-fill-0",
    offset: "0%",
    stopColor: "rgb(3,199,90)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube39-fill-1",
    offset: "100%",
    stopColor: "rgb(3,194,102)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube40-fill",
    className: "cube40-fill",
    x1: "16.318253",
    y1: "16.330000",
    x2: "-16.341747",
    y2: "-16.330000",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube40-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,131)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube40-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube41-fill",
    className: "cube41-fill",
    x1: "16.330000",
    y1: "16.330000",
    x2: "-16.517412",
    y2: "-16.075150",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube41-fill-0",
    offset: "0%",
    stopColor: "rgb(2,182,131)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube41-fill-1",
    offset: "100%",
    stopColor: "rgb(1,174,151)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cube42-fill",
    className: "cube42-fill",
    x1: "194.082760",
    y1: "278.600000",
    x2: "161.398253",
    y2: "245.997802",
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "cube42-fill-0",
    offset: "0%",
    stopColor: "rgb(1,162,180)"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "cube42-fill-1",
    offset: "100%",
    stopColor: "rgb(0,154,199)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cube2",
    transform: "matrix(0.33000000000000 0 0 0.33000000000000 -3.66678535655257 -2.71339523303233)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube3_tr'),
    transform: "translate(216.582507,149.579076) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube3'),
    transform: "translate(-109.944558,-178.482987)",
    opacity: "0"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube4_to'),
    transform: "translate(177.482449,139.600494)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube4'),
    d: "M177.740000,245.940000C168.740000,245.940000,161.410000,253.270000,161.410000,262.270000C161.410000,271.270000,168.740000,278.600000,177.740000,278.600000C186.740000,278.600000,194.070000,271.270000,194.070000,262.270000C194.070000,253.270000,186.740000,245.940000,177.740000,245.940000Z",
    transform: "scale(0.700000,0.700000) translate(-177.740000,-262.133331)",
    fill: "rgb(0,158,190)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube5_to'),
    transform: "translate(87.895476,139.696162)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube5'),
    d: "M177.740000,156.120000C168.740000,156.120000,161.410000,163.440000,161.410000,172.450000C161.410000,181.460000,168.740000,188.780000,177.740000,188.780000C186.740000,188.780000,194.070000,181.450000,194.070000,172.450000C194.070000,163.450000,186.740000,156.120000,177.740000,156.120000Z",
    transform: "scale(0.700000,0.700000) translate(-177.740000,-172.450000)",
    fill: "url(#cube5-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube6_to'),
    transform: "translate(42.610330,217.322500)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube6'),
    d: "M255.530000,116.100000C249.230000,116.100000,244.100000,121.230000,244.100000,127.530000C244.100000,133.830000,249.230000,138.960000,255.530000,138.960000C261.830000,138.960000,266.960000,133.830000,266.960000,127.530000C266.960000,121.220000,261.830000,116.100000,255.530000,116.100000Z",
    transform: "translate(-255.529999,-127.530000)",
    fill: "url(#cube6-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube7_to'),
    transform: "translate(135.365482,217.323500)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube7'),
    d: "M186.866780,71.726867C185.466513,71.355622,184.037669,71.170000,182.608825,71.170000C179.779715,71.170000,176.979181,71.912489,174.464416,73.368910C170.692268,75.553541,167.977465,79.066086,166.848679,83.278283C165.719892,87.490481,166.305718,91.888301,168.477560,95.657861C170.649403,99.427421,174.178647,102.140361,178.393736,103.268374C182.608825,104.396386,187.009664,103.810962,190.781812,101.640609C198.583299,97.142839,201.269525,87.133515,196.754379,79.351658C194.596825,75.553541,191.081869,72.854879,186.866780,71.726867Z",
    transform: "scale(0.700000,0.700000) translate(-182.616667,-87.500000)",
    fill: "url(#cube7-fill)",
    stroke: "none",
    strokeWidth: "1"
  })))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube8_tr'),
    transform: "translate(177.715488,217.350006) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube8'),
    transform: "translate(-177.715488,-217.350006)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube9_to'),
    transform: "translate(177.740005,174.863331)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube9'),
    d: "M177.740000,245.940000C168.740000,245.940000,161.410000,253.270000,161.410000,262.270000C161.410000,271.270000,168.740000,278.600000,177.740000,278.600000C186.740000,278.600000,194.070000,271.270000,194.070000,262.270000C194.070000,253.270000,186.740000,245.940000,177.740000,245.940000Z",
    transform: "scale(0.700000,0.700000) translate(-177.740000,-262.133331)",
    fill: "url(#cube9-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube10_to'),
    transform: "translate(177.740005,262.240554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube10'),
    d: "M177.740000,245.940000C168.740000,245.940000,161.410000,253.270000,161.410000,262.270000C161.410000,271.270000,168.740000,278.600000,177.740000,278.600000C186.740000,278.600000,194.070000,271.270000,194.070000,262.270000C194.070000,253.270000,186.740000,245.940000,177.740000,245.940000Z",
    transform: "translate(-177.740000,-262.270000)",
    fill: "url(#cube10-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube11_to'),
    transform: "translate(99.940000,217.350006)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('cube11'),
    r: "16.330000",
    transform: "translate(0.000002,0)",
    fill: "url(#cube11-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube12_to'),
    transform: "translate(255.531996,217.350006)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube12_ts'),
    transform: "scale(0.700000,0.700000)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('cube12'),
    r: "16.330000",
    transform: "translate(-0,0)",
    fill: "rgb(0,155,196)",
    stroke: "none",
    strokeWidth: "1"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube13_tr'),
    transform: "translate(138.824486,194.808133) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube13'),
    transform: "translate(-110.461867,-88.614486)",
    opacity: "0"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube14_to'),
    transform: "translate(130.270002,127.529994)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube14'),
    d: "M99.940000,111.200000C90.940000,111.200000,83.610000,118.520000,83.610000,127.530000C83.610000,136.540000,90.940000,143.860000,99.940000,143.860000C108.940000,143.860000,116.270000,136.530000,116.270000,127.530000C116.270000,118.530000,108.950000,111.200000,99.940000,111.200000Z",
    transform: "translate(-99.940002,-127.530000)",
    fill: "url(#cube14-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube15_to'),
    transform: "translate(177.740003,49.655719)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('cube15'),
    r: "16.330000",
    transform: "translate(0.000002,0)",
    fill: "url(#cube15-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube16_to'),
    transform: "translate(43.157166,127.529994)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('cube16'),
    r: "16.330000",
    transform: "translate(-0,0)",
    fill: "url(#cube16-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube17_to'),
    transform: "translate(88.153033,49.655719)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube17'),
    d: "M177.740000,245.940000C168.740000,245.940000,161.410000,253.270000,161.410000,262.270000C161.410000,271.270000,168.740000,278.600000,177.740000,278.600000C186.740000,278.600000,194.070000,271.270000,194.070000,262.270000C194.070000,253.270000,186.740000,245.940000,177.740000,245.940000Z",
    transform: "translate(-177.740000,-262.270000)",
    fill: "url(#cube17-fill)",
    stroke: "none",
    strokeWidth: "1"
  })))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube18_tr'),
    transform: "translate(216.582507,149.579076) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube18'),
    transform: "translate(-109.944558,-178.482987)",
    opacity: "0"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube19_to'),
    transform: "translate(177.482449,139.600494)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube19'),
    d: "M177.740000,245.940000C168.740000,245.940000,161.410000,253.270000,161.410000,262.270000C161.410000,271.270000,168.740000,278.600000,177.740000,278.600000C186.740000,278.600000,194.070000,271.270000,194.070000,262.270000C194.070000,253.270000,186.740000,245.940000,177.740000,245.940000Z",
    transform: "scale(0.700000,0.700000) translate(-177.740000,-262.133331)",
    fill: "rgb(0,158,190)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube20_to'),
    transform: "translate(87.895476,139.696162)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube20'),
    d: "M177.740000,156.120000C168.740000,156.120000,161.410000,163.440000,161.410000,172.450000C161.410000,181.460000,168.740000,188.780000,177.740000,188.780000C186.740000,188.780000,194.070000,181.450000,194.070000,172.450000C194.070000,163.450000,186.740000,156.120000,177.740000,156.120000Z",
    transform: "scale(0.700000,0.700000) translate(-177.740000,-172.450000)",
    fill: "url(#cube20-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube21_to'),
    transform: "translate(42.610330,217.322500)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube21'),
    d: "M255.530000,116.100000C249.230000,116.100000,244.100000,121.230000,244.100000,127.530000C244.100000,133.830000,249.230000,138.960000,255.530000,138.960000C261.830000,138.960000,266.960000,133.830000,266.960000,127.530000C266.960000,121.220000,261.830000,116.100000,255.530000,116.100000Z",
    transform: "translate(-255.529999,-127.530000)",
    fill: "url(#cube21-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube22_to'),
    transform: "translate(135.365482,217.323500)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube22'),
    d: "M186.866780,71.726867C185.466513,71.355622,184.037669,71.170000,182.608825,71.170000C179.779715,71.170000,176.979181,71.912489,174.464416,73.368910C170.692268,75.553541,167.977465,79.066086,166.848679,83.278283C165.719892,87.490481,166.305718,91.888301,168.477560,95.657861C170.649403,99.427421,174.178647,102.140361,178.393736,103.268374C182.608825,104.396386,187.009664,103.810962,190.781812,101.640609C198.583299,97.142839,201.269525,87.133515,196.754379,79.351658C194.596825,75.553541,191.081869,72.854879,186.866780,71.726867Z",
    transform: "scale(0.700000,0.700000) translate(-182.616667,-87.500000)",
    fill: "url(#cube22-fill)",
    stroke: "none",
    strokeWidth: "1"
  })))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube23_tr'),
    transform: "translate(177.715488,217.350006) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube23'),
    transform: "translate(-177.715488,-217.350006)",
    opacity: "0"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube24_to'),
    transform: "translate(177.740005,174.863331)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube24'),
    d: "M177.740000,245.940000C168.740000,245.940000,161.410000,253.270000,161.410000,262.270000C161.410000,271.270000,168.740000,278.600000,177.740000,278.600000C186.740000,278.600000,194.070000,271.270000,194.070000,262.270000C194.070000,253.270000,186.740000,245.940000,177.740000,245.940000Z",
    transform: "scale(0.700000,0.700000) translate(-177.740000,-262.133331)",
    fill: "url(#cube24-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube25_to'),
    transform: "translate(177.740005,262.240554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube25'),
    d: "M177.740000,245.940000C168.740000,245.940000,161.410000,253.270000,161.410000,262.270000C161.410000,271.270000,168.740000,278.600000,177.740000,278.600000C186.740000,278.600000,194.070000,271.270000,194.070000,262.270000C194.070000,253.270000,186.740000,245.940000,177.740000,245.940000Z",
    transform: "translate(-177.740000,-262.270000)",
    fill: "url(#cube25-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube26_to'),
    transform: "translate(99.940000,217.350006)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('cube26'),
    r: "16.330000",
    transform: "translate(0.000002,0)",
    fill: "url(#cube26-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube27_to'),
    transform: "translate(255.531996,217.350006)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube27_ts'),
    transform: "scale(0.700000,0.700000)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('cube27'),
    r: "16.330000",
    transform: "translate(-0,0)",
    fill: "url(#cube27-fill)",
    stroke: "none",
    strokeWidth: "1"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube28_tr'),
    transform: "translate(177.740000,127.530000) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube28'),
    transform: "translate(-177.740000,-127.530000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube29_to'),
    transform: "translate(177.740006,82.077657)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube29_ts'),
    transform: "scale(0.700000,0.700000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube29'),
    d: "M186.866780,71.726867C185.466513,71.355622,184.037669,71.170000,182.608825,71.170000C179.779715,71.170000,176.979181,71.912489,174.464416,73.368910C170.692268,75.553541,167.977465,79.066086,166.848679,83.278283C165.719892,87.490481,166.305718,91.888301,168.477560,95.657861C170.649403,99.427421,174.178647,102.140361,178.393736,103.268374C182.608825,104.396386,187.009664,103.810962,190.781812,101.640609C198.583299,97.142839,201.269525,87.133515,196.754379,79.351658C194.596825,75.553541,191.081869,72.854879,186.866780,71.726867Z",
    transform: "translate(-182.616667,-87.500000)",
    fill: "rgb(3,199,90)",
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube30_to'),
    transform: "translate(255.531995,127.530000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube30'),
    d: "M255.530000,116.100000C249.230000,116.100000,244.100000,121.230000,244.100000,127.530000C244.100000,133.830000,249.230000,138.960000,255.530000,138.960000C261.830000,138.960000,266.960000,133.830000,266.960000,127.530000C266.960000,121.220000,261.830000,116.100000,255.530000,116.100000Z",
    transform: "translate(-255.529999,-127.530000)",
    fill: "url(#cube30-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube31_to'),
    transform: "translate(99.940002,127.530000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube31'),
    d: "M99.940000,111.200000C90.940000,111.200000,83.610000,118.520000,83.610000,127.530000C83.610000,136.540000,90.940000,143.860000,99.940000,143.860000C108.940000,143.860000,116.270000,136.530000,116.270000,127.530000C116.270000,118.530000,108.950000,111.200000,99.940000,111.200000Z",
    transform: "translate(-99.940002,-127.530000)",
    fill: "url(#cube31-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube32_to'),
    transform: "translate(177.740005,174.863331)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube32_ts'),
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube32'),
    d: "M177.740000,156.120000C168.740000,156.120000,161.410000,163.440000,161.410000,172.450000C161.410000,181.460000,168.740000,188.780000,177.740000,188.780000C186.740000,188.780000,194.070000,181.450000,194.070000,172.450000C194.070000,163.450000,186.740000,156.120000,177.740000,156.120000Z",
    transform: "translate(-177.740000,-172.450000)",
    fill: "url(#cube32-fill)",
    stroke: "none",
    strokeWidth: "1"
  }))))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube33_tr'),
    transform: "translate(177.740000,127.530000) rotate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube33'),
    transform: "translate(-177.740000,-127.530000)",
    opacity: "0"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube34_to'),
    transform: "translate(177.740006,82.077657)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube34_ts'),
    transform: "scale(0.700000,0.700000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube34'),
    d: "M186.866780,71.726867C185.466513,71.355622,184.037669,71.170000,182.608825,71.170000C179.779715,71.170000,176.979181,71.912489,174.464416,73.368910C170.692268,75.553541,167.977465,79.066086,166.848679,83.278283C165.719892,87.490481,166.305718,91.888301,168.477560,95.657861C170.649403,99.427421,174.178647,102.140361,178.393736,103.268374C182.608825,104.396386,187.009664,103.810962,190.781812,101.640609C198.583299,97.142839,201.269525,87.133515,196.754379,79.351658C194.596825,75.553541,191.081869,72.854879,186.866780,71.726867Z",
    transform: "translate(-182.616667,-87.500000)",
    fill: "rgb(3,199,90)",
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube35_to'),
    transform: "translate(255.531995,127.530000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube35'),
    d: "M255.530000,116.100000C249.230000,116.100000,244.100000,121.230000,244.100000,127.530000C244.100000,133.830000,249.230000,138.960000,255.530000,138.960000C261.830000,138.960000,266.960000,133.830000,266.960000,127.530000C266.960000,121.220000,261.830000,116.100000,255.530000,116.100000Z",
    transform: "translate(-255.529999,-127.530000)",
    fill: "url(#cube35-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube36_to'),
    transform: "translate(177.740005,174.863331)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube36_ts'),
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube36'),
    d: "M177.740000,156.120000C168.740000,156.120000,161.410000,163.440000,161.410000,172.450000C161.410000,181.460000,168.740000,188.780000,177.740000,188.780000C186.740000,188.780000,194.070000,181.450000,194.070000,172.450000C194.070000,163.450000,186.740000,156.120000,177.740000,156.120000Z",
    transform: "translate(-177.740000,-172.450000)",
    fill: "url(#cube36-fill)",
    stroke: "none",
    strokeWidth: "1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube37_to'),
    transform: "translate(99.940002,127.530000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube37'),
    d: "M99.940000,111.200000C90.940000,111.200000,83.610000,118.520000,83.610000,127.530000C83.610000,136.540000,90.940000,143.860000,99.940000,143.860000C108.940000,143.860000,116.270000,136.530000,116.270000,127.530000C116.270000,118.530000,108.950000,111.200000,99.940000,111.200000Z",
    transform: "translate(-99.940002,-127.530000)",
    fill: "url(#cube37-fill)",
    stroke: "none",
    strokeWidth: "1"
  })))), /*#__PURE__*/React.createElement("g", {
    className: cx('cube38_tr'),
    transform: "translate(138.824486,194.808133) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube38'),
    transform: "translate(-110.461867,-88.614486)",
    opacity: "0"
  }, /*#__PURE__*/React.createElement("g", {
    className: cx('cube39_to'),
    transform: "translate(130.270002,127.529994)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube39'),
    d: "M99.940000,111.200000C90.940000,111.200000,83.610000,118.520000,83.610000,127.530000C83.610000,136.540000,90.940000,143.860000,99.940000,143.860000C108.940000,143.860000,116.270000,136.530000,116.270000,127.530000C116.270000,118.530000,108.950000,111.200000,99.940000,111.200000Z",
    transform: "translate(-99.940002,-127.530000)",
    fill: "url(#cube39-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube40_to'),
    transform: "translate(43.157166,127.529994)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('cube40'),
    r: "16.330000",
    transform: "translate(-0,0)",
    fill: "url(#cube40-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube41_to'),
    transform: "translate(177.740003,49.655719)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: cx('cube41'),
    r: "16.330000",
    transform: "translate(0.000002,0)",
    fill: "url(#cube41-fill)",
    stroke: "none",
    strokeWidth: "1"
  })), /*#__PURE__*/React.createElement("g", {
    className: cx('cube42_to'),
    transform: "translate(88.153033,49.655719)"
  }, /*#__PURE__*/React.createElement("path", {
    className: cx('cube42'),
    d: "M177.740000,245.940000C168.740000,245.940000,161.410000,253.270000,161.410000,262.270000C161.410000,271.270000,168.740000,278.600000,177.740000,278.600000C186.740000,278.600000,194.070000,271.270000,194.070000,262.270000C194.070000,253.270000,186.740000,245.940000,177.740000,245.940000Z",
    transform: "translate(-177.740000,-262.270000)",
    fill: "url(#cube42-fill)",
    stroke: "none",
    strokeWidth: "1"
  }))))));
});

export { LoadingCube as default };
